module.exports = __webpack_public_path__ + "static/media/Maf_ManuelBarrera.e64a759b.jpg";